import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { POWER_SUPPLIES } from 'apollo-client/queries/getAvailablePowerSupplies';
import { powerSupplies } from 'cache';
import { Query, QueryGetAvailablePowerSuppliesArgs } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const PowerSupplyFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [onGetAvailablepowerSupplies, { loading, data }] = useLazyQuery<Query, QueryGetAvailablePowerSuppliesArgs>(
    POWER_SUPPLIES
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.powerSupplies.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.powerSupplies.placeholder' })}
        options={data?.getAvailablePowerSupplies?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.powerSupplies?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailablepowerSupplies({ variables: { inputPowerSupply: e } });
        }}
        onClick={(): void => {
          onGetAvailablepowerSupplies({ variables: { inputPowerSupply: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          powerSupplies(x?.map(({ value }) => value) as string[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
